import { memo, useMemo } from "react"
import { Security, SecurityCategory_CategoryCode } from '../../proto/generated/security'
import { Box } from "@mui/material"
import { getSecurityKey } from "../../util/security"
import { toLocaleStringIn } from "../../util/general"
import OrderBookItem from "../orderBook/OrderBookItem"
import { formatLargeNumber } from "../../util/screener"
import { formatUnixTimestampForOrderBook } from "../../util/dateTime"
import { useOrderBookOverviewTick } from "../../hooks/useSecurityMarketTicks"

export type OrderBookOverviewProps = {
    security: Security
}

const OrderBookOverview: React.FC<OrderBookOverviewProps> = ({ security }) => {
    const securityKey = useMemo(() => security ? getSecurityKey(security.exchange, security.code) : '', [security])
    const orderBook = useOrderBookOverviewTick(securityKey)
    const priceMultiplier = security?.priceMultiplier ?? 100
    const isIndex = security.categoryCode === SecurityCategory_CategoryCode.INDEX

    if (!orderBook) return null

    return (
        <Box display="flex" flexDirection="row" gap={1} justifyContent="space-between" width="100%">
            <Box width="50%">
                <OrderBookItem
                    title="Open"
                    value={toLocaleStringIn(orderBook.open / priceMultiplier)}
                />
                <OrderBookItem
                    title="Low"
                    value={toLocaleStringIn(orderBook.low / priceMultiplier)}
                />
                {!isIndex && (
                    <>
                        <OrderBookItem
                            title="Volume"
                            value={formatLargeNumber(orderBook.volumeTradedToday)}
                        />
                        <OrderBookItem
                            title="Lower Circuit"
                            value={toLocaleStringIn(orderBook.lowerCircuit / priceMultiplier)}
                        />
                    </>
                )}
            </Box>
            <Box width="50%">
                <OrderBookItem
                    title="High"
                    value={toLocaleStringIn(orderBook.high / priceMultiplier)}
                />
                <OrderBookItem
                    title="Prev. Close"
                    value={toLocaleStringIn(orderBook.close / priceMultiplier)}
                />
                {!isIndex && (
                    <>
                        <OrderBookItem
                            title="LTT"
                            value={orderBook.lastTradedTime ? formatUnixTimestampForOrderBook(orderBook.lastTradedTime) : '-'}
                        />
                        <OrderBookItem
                            title="Upper Circuit"
                            value={toLocaleStringIn(orderBook.upperCircuit / priceMultiplier)}
                        />
                    </>
                )}
            </Box>
        </Box>
    )
}

export default memo(OrderBookOverview)
